import { render, staticRenderFns } from "./ChapterWaiverTile.vue?vue&type=template&id=0705a499&scoped=true&"
import script from "./ChapterWaiverTile.vue?vue&type=script&lang=js&"
export * from "./ChapterWaiverTile.vue?vue&type=script&lang=js&"
import style0 from "./ChapterWaiverTile.vue?vue&type=style&index=0&id=0705a499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0705a499",
  null
  
)

export default component.exports